import PDFObject from "pdfobject";
import { useTranslations } from "../../hooks/useTranslations";
import ModalDialog from "./ModalDialog";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  src: string | undefined;
}

const PdfPreview = ({ isOpen, onClose, title, src }: Props) => {
  const { i18n } = useTranslations();
  return (
    <ModalDialog title={title} isOpen={isOpen} onClose={onClose} size="large">
      <div
        style={{ height: window.innerHeight - 180 }}
        ref={(elem) =>
          src &&
          elem &&
          PDFObject.embed(src, elem, {
            pdfOpenParams: { view: "FitV", page: 1 },
            fallbackLink: `<p>${i18n.documents.pdfFallback("<a href='[url]'>PDF</a>")}</p>`,
          })
        }
      />
    </ModalDialog>
  );
};

export default PdfPreview;
